import { render, staticRenderFns } from "./FormRegistrationType.vue?vue&type=template&id=1a60483f"
import script from "./FormRegistrationType.vue?vue&type=script&lang=js"
export * from "./FormRegistrationType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports